export function getDetailHoliday()
{
    return({
        type:"GET_DETAIL_HOLIDAY"
    })
}